import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loadedImageLoadingItemAction, registerImageLoadingItemAction } from '../../../redux/image-loading/image-loading.actions';
import { registerLinkOpeningAction } from '../../../redux/giveaway-landing/giveaway-landing.actions';
import { ImageLoadingComponent } from './image-loading';
const mapDispatchToProps = dispatch => bindActionCreators({
  onLoad: loadedImageLoadingItemAction,
  onRegister: registerImageLoadingItemAction,
  onRegisterLinkOpen: registerLinkOpeningAction
}, dispatch);
export const ImageLoading = connect(undefined, mapDispatchToProps)(ImageLoadingComponent);